export function changeFormatDate(dateToConvert: string): string {

  return dateToConvert.replace(/(\d\d)-(\d\d)-(\d{4})/, '$3-$1-$2');
}
